/**
 * AUTO-GENERATED AT BUILD TIME - DO NOT EDIT.
 *
 * Source: https://cc-fe-bifrost.prod-east.frontend.public.atl-paas.net/bifrost-static/assets/master/preload-query-batch-config.json
 */
// prettier-ignore
export const Q: readonly string[] = [
	"ActiveCommentsQuery",
	"ApprovalsContextApprovalsDataQuery",
	"ArchivedPageBannerV2ArchivedPageBannerContainerQuery",
	"ArchivedPageBannerV2ArchivedPageBannerQuery",
	"BlogTreeRootComponentQuery",
	"CollabDraftQuery",
	"CollabDraftWithRelevanceQuery",
	"ContentBlogUnifiedQuery",
	"ContentHeaderPresenceContentSettingsQuery",
	"ContentHeaderUnifiedQuery",
	"ContentPrerequisitesQuery",
	"ContentRedirectQuery",
	"ContentTypesHeaderQuery",
	"ContentUnifiedQuery",
	"ContentUnifiedWithSpaceKeyQuery",
	"CookieConsentPreferences",
	"CoverPictureQuery",
	"CustomHeaderFooterQuery",
	"DatabaseContainerQuery",
	"EditContentButtonQuery",
	"EditorContentStateQuery",
	"EditorPreferencesQuery",
	"EmojiTitleQuery",
	"EndOfPageRecommendationQuery",
	"FollowingFeedWithSortByStorageSnippetsQuery",
	"FooterCreateButtonsQuery",
	"ForgeExtensionList",
	"GlobalNavigationComponentQuery",
	"GrantAccessDialogLoaderQuery",
	"HomeRecentWorkQuery",
	"InlineCommentsFocusedInlineCommentQuery",
	"InvitedAppShortcutsRecommendationsQuery",
	"LegacyMacroRendererQueryBodyQuery",
	"LivePagesByLineLastUpdatedQuery",
	"LocalStorageQuery",
	"NativeCollabQuery",
	"NotFoundContainerQuery",
	"NotificationsButtonQuery",
	"ObjectCommentContainerPreloadObjectCommentsQuery",
	"PageRestrictionsContextQuery",
	"PageTreeQuery",
	"PageTreeQueryWithSpaceKeyQuery",
	"PermissionCheckAddCommentQuery",
	"PersistentInviteEligibleQuery",
	"PersonalizedTemplatesV2AllTemplatesQuery",
	"PopularFeedWithTimeGranularityStorageSnippetsV2Query",
	"ReactionsContentQuery",
	"RendererContentStateQuery",
	"RestrictedPageWithCanViewQuery",
	"ScreenQuery",
	"SiteInformationQuery",
	"SmartCreateFeedbackBannerQuery",
	"SmartCreatePageEditorDataWrapperComponentQuery",
	"SpaceNavigationQuery",
	"SpaceOverviewIdQuery",
	"SpaceOverviewQuery",
	"SpaceQuery",
	"SpaceRestrictionCheckQuery",
	"ThemeQuery",
	"TopNavigationQuery",
	"UserSettingsQuery",
	"ViewSpaceExternalCollaboratorsDialogQuery",
	"WebItemLocationQuery_page.metadata.banner",
	"WebItemLocationQuery_system.content.action_system.content.button_system.editor.precursor.buttons",
	"WebItemLocationQuery_system.content.action_system.editor.precursor.buttons",
	"WebItemLocationQuery_system.content.byline",
	"WebItemLocationQuery_system.header_left",
	"WebItemLocationQuery_system.user",
	"WebPanelLocationQuery_atl.footer",
	"WebPanelLocationQuery_atl.general",
	"WebPanelLocationQuery_atl.general_atl.footer",
	"WebPanelLocationQuery_atl.page.content.footer.actions",
	"WelcomeMessagesQuery",
	"WhiteboardUnifiedQuery",
	"bifrost-ssr/prepare/preloadQuery/editor/nodeDataProvidersData/fetch:AdfDocQuery",
	"bifrost-ssr/prepare/preloadQuery/editor/syncedBlocksData/fetch:SyncBlockReferences",
	"bifrost-ssr/prepare/preloadQuery/renderer/syncedBlocksData/fetch:SyncBlockReferences",
	"contentAppearanceQuery",
	"contentSmartLinksORS",
	"fetchMentionsProviderDataQuery",
	"graphqlHelpersDSPIsActionEnabledForContentQuery",
	"graphqlHelpersFetchMediaTokenQuery",
	"loomUserPermissionQuery",
	"multiMacroQueryWithAppKeyQuery",
	"onboardingStateGetOnboardingStateQuery",
	"onboardingStateGetOnboardingStateQuery_aifc-onboarding_hasSeenAIFCSpotlight_9",
	"onboardingStateGetOnboardingStateQuery_auto-page-emoji_emojiTitleDiscovered",
	"onboardingStateGetOnboardingStateQuery_create-with-rovo-announcement-splash_hasSeenSplashModal",
	"onboardingStateGetOnboardingStateQuery_creation-focused-nav_shouldShowSpotlight_2",
	"onboardingStateGetOnboardingStateQuery_creation-focused-nav_shouldShowSpotlight_4",
	"onboardingStateGetOnboardingStateQuery_creation-focused-nav_shouldShowSpotlight_6",
	"onboardingStateGetOnboardingStateQuery_cross-join-nth-user-onboarding_trendingPages_2",
	"onboardingStateGetOnboardingStateQuery_editor-state_editorOnboardingEligiblity_12",
	"onboardingStateGetOnboardingStateQuery_land-users-in-editor-with-revamped-bpqa_revampedBpqaShownAt",
	"onboardingStateGetOnboardingStateQuery_onboarding-intent-experiences_onboardingIntentExperienceClosed_18",
	"onboardingStateGetOnboardingStateQuery_onboarding-origin-state_attributes_65",
	"onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_10",
	"onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_5",
	"onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_6",
	"onboardingStateGetOnboardingStateQuery_onboarding-state_nthUserOnboardingCompletedTimestamp",
	"onboardingStateGetOnboardingStateQuery_storage-enforcement-state_flagsDismissedFreeThreshold_158",
	"onboardingStateGetOnboardingStateQuery_storage-enforcement-state_flagsDismissedFreeThreshold_159",
	"onboardingStateGetOnboardingStateQuery_storage-enforcement-state_flagsDismissedFreeThreshold_160",
	"pageButtons",
	"preloadAutohighlightsQuery",
	"preloadContentSmartLinksQuery",
	"preloadCreateSpaceQuery",
	"preloadEditButtonWithSpaceKeyQuery",
	"preloadEditorNodeDataProvidersDataQuery",
	"preloadForgeApps_FetchPreFilteredForgeAppsQuery",
	"preloadLegacyBridgeQuery",
	"preloadOperationsQuery",
	"preloadPageStatusQueryDataQuery",
	"preloadPendingRequestExistsQuery",
	"preloadPersonalSpaceDetailsQuery",
	"preloadShareAndRestrictButtonQuerySpaceOverviewQuery",
	"preloadSpaceBlogCountQuery",
	"preloadTemplatesCollectionEligibleQuery",
	"relay_ApprovalsContextApprovalsDataQuery",
	"relay_ArchivedPageBannerV2ArchivedPageBannerContainerQuery",
	"relay_BlogTreeRootComponentQuery",
	"relay_CollabDraftQuery",
	"relay_ContentHeaderPresenceContentSettingsQuery",
	"relay_ContentHeaderUnifiedQuery",
	"relay_ContentTypesHeaderQuery",
	"relay_ContentUnifiedQuery",
	"relay_ContentUnifiedWithSpaceKeyQuery",
	"relay_CoverPictureQuery",
	"relay_CustomHeaderFooterQuery",
	"relay_EditContentButtonQuery",
	"relay_EditorContentStateQuery",
	"relay_EditorPreferencesQuery",
	"relay_EmojiTitleQuery",
	"relay_EndOfPageRecommendationQuery",
	"relay_FollowingFeedWithSortByStorageSnippetsQuery",
	"relay_FooterCreateButtonsQuery",
	"relay_GlobalNavigationComponentQuery",
	"relay_HomeRecentWorkQuery",
	"relay_InvitedAppShortcutsRecommendationsQuery",
	"relay_LivePagesByLineLastUpdatedQuery",
	"relay_NativeCollabQuery",
	"relay_NotFoundContainerQuery",
	"relay_NotificationsButtonQuery",
	"relay_PageRestrictionsContextQuery",
	"relay_PageTreeQuery",
	"relay_PageTreeQueryWithSpaceKeyQuery",
	"relay_PermissionCheckAddCommentQuery",
	"relay_PersistentInviteEligibleQuery",
	"relay_PersonalizedTemplatesV2AllTemplatesQuery",
	"relay_PopularFeedWithTimeGranularityStorageSnippetsV2Query",
	"relay_ReactionsContentQuery",
	"relay_RendererContentStateQuery",
	"relay_RestrictedPageWithCanViewQuery",
	"relay_ScreenQuery",
	"relay_SiteInformationQuery",
	"relay_SmartCreateFeedbackBannerQuery",
	"relay_SmartCreatePageEditorDataWrapperComponentQuery",
	"relay_SpaceNavigationQuery",
	"relay_SpaceOverviewIdQuery",
	"relay_SpaceOverviewQuery",
	"relay_SpaceQuery",
	"relay_SpaceRestrictionCheckQuery",
	"relay_ThemeQuery",
	"relay_TopNavigationQuery",
	"relay_ViewSpaceExternalCollaboratorsDialogQuery",
	"relay_WebItemLocationQuery_page.metadata.banner",
	"relay_WebItemLocationQuery_system.content.byline",
	"relay_WebItemLocationQuery_system.header_left",
	"relay_WebPanelLocationQuery_atl.footer",
	"relay_WebPanelLocationQuery_atl.general",
	"relay_WebPanelLocationQuery_atl.page.content.footer.actions",
	"relay_WelcomeMessagesQuery",
	"relay_WhiteboardUnifiedQuery",
	"relay_contentAppearanceQuery",
	"relay_fetchMentionsProviderDataQuery",
	"relay_graphqlHelpersDSPIsActionEnabledForContentQuery",
	"relay_graphqlHelpersFetchMediaTokenQuery",
	"relay_graphqlHelpersFetchMediaTokenWithMediaItemsQuery",
	"relay_loomUserPermissionQuery",
	"relay_multiMacroQueryWithAppKeyQuery",
	"relay_onboardingStateGetOnboardingStateQuery",
	"relay_onboardingStateGetOnboardingStateQuery_aifc-onboarding_hasSeenAIFCSpotlight_9",
	"relay_onboardingStateGetOnboardingStateQuery_auto-page-emoji_emojiTitleDiscovered",
	"relay_onboardingStateGetOnboardingStateQuery_create-with-rovo-announcement-splash_hasSeenSplashModal",
	"relay_onboardingStateGetOnboardingStateQuery_creation-focused-nav_shouldShowSpotlight_6",
	"relay_onboardingStateGetOnboardingStateQuery_cross-join-nth-user-onboarding_trendingPages_2",
	"relay_onboardingStateGetOnboardingStateQuery_editor-state_editorOnboardingEligiblity_12",
	"relay_onboardingStateGetOnboardingStateQuery_land-users-in-editor-with-revamped-bpqa_revampedBpqaShownAt",
	"relay_onboardingStateGetOnboardingStateQuery_onboarding-intent-experiences_onboardingIntentExperienceClosed_18",
	"relay_onboardingStateGetOnboardingStateQuery_onboarding-origin-state_attributes_65",
	"relay_onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_10",
	"relay_onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_5",
	"relay_onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_6",
	"relay_onboardingStateGetOnboardingStateQuery_onboarding-state_nthUserOnboardingCompletedTimestamp",
	"relay_onboardingStateGetOnboardingStateQuery_storage-enforcement-state_flagsDismissedFreeThreshold_159",
	"relay_onboardingStateGetOnboardingStateQuery_storage-enforcement-state_flagsDismissedFreeThreshold_160",
	"relay_onboardingStateGetOnboardingStateQuery_storage-enforcement-state_flagsDismissedFreeThreshold_162",
	"relay_preloadAutohighlightsQuery",
	"relay_preloadContentSmartLinksQuery",
	"relay_preloadCreateSpaceQuery",
	"relay_preloadEditButtonWithSpaceKeyQuery",
	"relay_preloadEditorNodeDataProvidersDataQuery",
	"relay_preloadForgeApps_FetchPreFilteredForgeAppsQuery",
	"relay_preloadPersonalSpaceDetailsQuery",
	"relay_preloadShareAndRestrictButtonQuerySpaceOverviewQuery",
	"relay_preloadTemplatesCollectionEligibleQuery",
	"relay_shortcutsSmartLinksQuery",
	"relay_useAnalyticsByLineQuery",
	"relay_useAudioContentQuery",
	"relay_useConfluenceStandardToPremiumExperimentQuery",
	"relay_useConnectorOnboardingStateQuery",
	"relay_useConnectorOnboardingTeamTypeQuery",
	"relay_useConnectorStatesQuery",
	"relay_useContentClassificationContentDataClassificationQuery",
	"relay_useEditorContentModeValueQuery",
	"relay_useEmojiEverSetPropertyQuery",
	"relay_useFabricEligibilityMigrationQuery",
	"relay_useFeatureDiscoveryFeatureDiscoveryQuery",
	"relay_useFeedTypeSelectorRefreshQuery",
	"relay_useGetCurrentStorageUsageQuery",
	"relay_useGetTeamAndSubanchorGetPersonalSpaceKeyQuery",
	"relay_useGetTeamAndSubanchorGetSubanchorsAGGQuery",
	"relay_useHomeWidgetStateQuery",
	"relay_useIsEligibleForNthUserHomeOnboardingLicensedUserCountQuery",
	"relay_useIsLoomEntryPointsEnabledQuery",
	"relay_useIsUserViewingSpaceAsAnonQuery",
	"relay_useLicensedProductsQueryForGlobalAppShortcutsQuery",
	"relay_useLoomTenantProvisionStatusQuery",
	"relay_usePopularFeedWithTimeGranularityStorageQuery",
	"relay_usePreloadCommentButtonQuery",
	"relay_useReadTimeQuery",
	"relay_useRegisterAdminAnnouncementBannerQuery",
	"relay_useShareAndRestrictButtonDataQuery",
	"relay_useSpaceBaseQueryBaseQuery",
	"relay_useSpaceDetailQuery",
	"relay_useSpaceEnabledContentTypesQuery",
	"relay_useSpaceViewsDataSpaceRootQuery",
	"relay_useSpaceViewsOptionsPersistenceQuery",
	"relay_useSpacesDataMyVisitedSpacesQuery",
	"relay_useSpacesDataStarredSpacesQuery",
	"relay_useTitleContentPropertiesForEditorQuery",
	"relay_useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery",
	"relay_useTitleContentPropertiesForPublishedPageQuery",
	"relay_useUserByLicensedProductsQuery",
	"requireSuperBatchFrontendResourceRenderQuery",
	"rightPanel",
	"searchResults",
	"shortcutsSmartLinksQuery",
	"sidenavSmartLinksORS",
	"useAnalyticsByLineQuery",
	"useAudioContentQuery",
	"useBlogPostsQueryQuery",
	"useConfluenceStandardToPremiumExperimentQuery",
	"useConnectorOnboardingStateQuery",
	"useConnectorOnboardingTeamTypeQuery",
	"useConnectorStatesQuery",
	"useContentClassificationContentDataClassificationQuery",
	"useEditorContentModeValueQuery",
	"useEmojiEverSetPropertyQuery",
	"useFabricEligibilityMigrationQuery",
	"useFeatureDiscoveryFeatureDiscoveryQuery",
	"useFeedTypeSelectorRefreshQuery",
	"useFollowingFeedWithSortByStorageFeedContentQuery",
	"useGetCurrentStorageUsageQuery",
	"useGetTeamAndSubanchorGetPersonalSpaceKeyQuery",
	"useGetTeamAndSubanchorGetSubanchorsAGGQuery",
	"useHomeWidgetStateQuery",
	"useIsEligibleForNthUserHomeOnboardingLicensedUserCountQuery",
	"useIsLoomEntryPointsEnabledQuery",
	"useIsUserViewingSpaceAsAnonQuery",
	"useLicensedProductsQueryForGlobalAppShortcutsQuery",
	"useLoomTenantProvisionStatusQuery",
	"usePageTreeSearchQueryQuery",
	"usePopularFeedWithTimeGranularityStorageQuery",
	"usePreloadCommentButtonQuery",
	"useReadTimeQuery",
	"useRegisterAdminAnnouncementBannerQuery",
	"useShareAndRestrictButtonDataQuery",
	"useShortcutsSpaceNavigationQuery",
	"useSpaceBaseQueryBaseQuery",
	"useSpaceDetailQuery",
	"useSpaceEnabledContentTypesQuery",
	"useSpaceViewsDataSpaceRootQuery",
	"useSpaceViewsOptionsPersistenceQuery",
	"useSpacesDataAnonymousSpacesQuery",
	"useSpacesDataMyVisitedSpacesQuery",
	"useSpacesDataStarredSpacesQuery",
	"useTitleContentPropertiesForEditorQuery",
	"useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery",
	"useTitleContentPropertiesForPublishedPageQuery",
	"useUserByLicensedProductsQuery"
];

// prettier-ignore
export const R: Readonly<Record<string, string>> = {
	"prod-apne": "9e5f7b0efed7ff7fb7a6fffcffffef1d8fc1c52cbe87a12168446101ef35f4143ff7bdcf07",
	"prod-apne2": "9e5f7b5efed7fbffb7a6fffcffffff1d8fc1c528be87a92168446301ef35e474bff7b0cf07",
	"prod-apse": "9edf7b7efed7ffffb7a6fffcffffeffd9fdbd7effee7fdffef7fe357efbfff3cbff7bddf07",
	"prod-apse2": "9edf7fdefed7ffffbfa7fffcfffffffd9fd1d7efbffffdffef7fe357eff7ff74bff7bdff07",
	"prod-apsouth": "9e7f7b4efed7ffffb7a7fffcffffff3d8fc1c52cbe87a92160c46101ef35e474bff7bccf07",
	"prod-cacentral": "9eff7b6efedfffffbea7fffcffffff3d8fc1cd2cbe87a92168446301ef35e4f4bfffbcef07",
	"prod-east": "9edf7f7efedfffffbfa7fffcffffffdd9ffbdffffffffdffef7fe3dfeffffff4bfffbdef07",
	"prod-eucentral": "9edf7f1efed6ffffbfa6fffcffffffdd9fd1c7efbee7ed2fee57e301eff7f774bff7bdff07",
	"prod-eucentral2": "9edf7b06fed7ff7fb7a6f7fcffff2f000000000000000000000000000000e014bff7bccf07",
	"prod-euwest": "9edf7ffefedfffffffa7fffcffffffdd9fdfd7effffffdffef7fe3d7efffff74bfffbdff07",
	"prod-euwest2": "9eff7b7efedfffffbfa7fffcffffbf3d8fc1c52cbe87a90160446301ef35f474bfffbcff07",
	"prod-west2": "9edf7f5effdfffffb7a7fffcffffffdd9ff9dfeffffffdffef7fe3d7efffff74bfffbddf07",
	"stg-east": "31b3c90eeacf2d7eb6a5ea730a37c0bfbfc8dd6dfeefffdfffec7fffeff50d142ff4588d06"
};

export const generatedAt: string | null = "2026-08-07T03:08:37.579Z";
